import ShareVideoPage from '@anm/components/share/ShareVideoPage';
import { useState, FC } from 'react';
import config from '../../../../config';

import { ShareButtonWrapper } from './Wrapper';
import { CUSTOMIZE_WEBINAR_ROUTE } from '@anm/constants/routes';
import useNotStableWarning from '../../../my-projects/MyStreamsSection/hooks/useNotStableWarning';
import Tooltip from '@anm/components/Tooltip';
import { notStableTooltip } from '@anm/components/dropdown-actions/NotStableTooltip';

type ShareVideoProps = {
  hostId: string;
  disabled?: boolean;
  projectId?: string;
  isWebinar?: boolean;
};

const ShareVideo: FC<ShareVideoProps> = ({ hostId, projectId, isWebinar = false, disabled = false }) => {
  const [showShareDialog, setShowShareDialog] = useState(false);

  const shareLink = isWebinar ? `${config().urls.webinarUrl}${hostId}` : `${config().urls.videoLanding}${hostId}`;
  const landingTabUrl = isWebinar
    ? `${config().urls.wave}${CUSTOMIZE_WEBINAR_ROUTE}/${hostId}`
    : `${config().urls.wave}video/${projectId}/landing`;

  const { checkUpload, isNotStable } = useNotStableWarning({
    projectId: projectId || ''
  });

  const handleClick = () => checkUpload({ cb: () => setShowShareDialog(true), showWarning: false });

  return (
    <Tooltip renderContent={isNotStable ? notStableTooltip : undefined}>
      <ShareButtonWrapper
        size="large"
        icon="images/dashboard/share-blue.svg"
        iconSize="small"
        variant="white-blue-border-share"
        onClick={handleClick}
        disabled={disabled || isNotStable}
      >
        Share
      </ShareButtonWrapper>

      {showShareDialog && (
        <ShareVideoPage {...{ shareLink, isWebinar, landingTabUrl }} onClose={() => setShowShareDialog(false)} />
      )}
    </Tooltip>
  );
};

export default ShareVideo;
